import React from 'react'
import loadable from '@loadable/component'
import styled from '@emotion/styled'

export interface Props {
    sponsor?: 'bullsnbears' | 'herd-on-the-terrace'
    className?: string
}

const LogoPlaceholder = styled('div')({ width: '200px', height: '40px' })

export const LazyBullsNBearsLogo = loadable(
    () => import('component-library/advertising/SponsoredTopic/BullsNBearsLogo'),
    { fallback: <LogoPlaceholder /> }
)

export const LazyHerdOnTheTerraceLogo = loadable(
    () => import('component-library/advertising/SponsoredTopic/HerdNTTerraceLogo'),
    { fallback: <LogoPlaceholder /> }
)

export const SponsoredTopic: React.FC<Props> = props => {
    if (props.sponsor === 'bullsnbears') {
        return <LazyBullsNBearsLogo className={props.className} />
    }

    if (props.sponsor === 'herd-on-the-terrace') {
        return <LazyHerdOnTheTerraceLogo className={props.className} />
    }

    return null
}
